<template>
  <div class="tab">
    <el-footer class="tab__footer page__active_bar">
      <el-button
        v-if="$can('update', 'cameras_config')"
        :disabled="!camera.id_model"
        id="saveConfigPushCamera"
        class="page__active_button"
        type="primary"
        :loading="fetch"
        @click="onSave"
      >Сохранить конфигурацию</el-button>
      <el-button
        v-if="$can('delete', 'cameras_config')"
        :disabled="!camera.id_model"
        id="deleteConfigPushCamera"
        class="page__active_button"
        type="warning"
        :loading="fetch"
        @click="onReset"
      >Сбросить конфигурацию камеры</el-button>
      <el-button
        v-if="$can('delete', 'cameras_config')"
        :disabled="!camera.id_model"
        id="resetConfigPushCamera"
        class="page__active_button"
        type="warning"
        :loading="fetch"
        @click="onResetConfiguration"
      >Сбросить значения параметров конфигурации</el-button>
    </el-footer>
    <main class="page_container">
      <div
        v-if="!camera.id_model"
        class="section__unavailable"
      >
        Редактирование конфигурации у этой камеры недоступно, так как не задана модель камеры
      </div>
      <div v-else>
        <json-editor
          disabled=""
          :json="form.config_template"
          :options="options"
          @change="setConfig"
          :completer="completer"
        />
        <el-row style="margin-top: 20px" :gutter="20">
          <el-col>
            Пароли камеры
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px" :gutter="20">
          <el-col v-for="input in inputs" :key="input.key" :span="8">
            <div class="camera-config__password-action">
              <span>{{ input.label }}</span>
              <show-parameter-button
                v-if="authKeys[input.key] === null"
                :parameter="input.type"
                :is-parameter-showed="authKeys[input.key] !== null"
                :on-click="requestAuthKey"
              />
              <el-input v-else class="camera-config__password-input" :value="authKeys[input.key]" readonly>
                <el-tooltip slot="append" content="Скопировать">
                  <el-button size="small" @click="copyData(authKeys[input.key])">
                    <fa :icon="['far', 'copy']" />
                  </el-button>
                </el-tooltip>
              </el-input>
            </div>
          </el-col>
        </el-row>
        <config-editor-list
          v-if="$can('read', 'camera_config_parameters')"
          ref="configEditorList"
          :parsed-replacers="form.parsed_replacers"
          :available-config-templates="form.available_config_templates"
          :model-parameters="form.model_parameters"
          :model-parameters-for-send="form.model_parameters_for_send"
        />
      </div>
    </main>
  </div>
</template>
<script>
import JsonEditor from "@/components/Cameras/components/Camera/features/JsonEditor";
import { mapActions, mapMutations, mapState } from "vuex";
import copyBuffer from "@/core/mixins/copyBuffer";
import ConfigEditorList from "./ConfigEditorList";
import ShowParameterButton from "@/core/components/features/ShowParameterButton";

export default {
  name: "CameraConfig",
  components: { ShowParameterButton, JsonEditor, ConfigEditorList },
  mixins: [copyBuffer],
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      fetch: false,
      loading: true,
      authKeys: { user_key: null, admin_key: null },
      options: {
        modes: ["code", "text", "form", "preview"],
        autocomplete: {
          filter: "contain",
          getOptions: () => {return ["test"]}
        }
      },
      inputs: [
        { label: "User", key: "user_key", type: "user" },
        { label: "Admin", key: "admin_key", type: "admin" },
      ],
      completer: {
        identifierRegexps: [/[a-zA-Z_0-9#]/],
        getCompletions(editor, session, pos, prefix, callback) {
          // TODO: Будет работать после обновления пакета jsoneditor, ждет проверки и добавления в whiltelist. DEVOPS-5538
          // TODO: Использовать то, что приходит с бэкенда
          var wordList = [
            { replacer_name: "#resolution_main" },
            { replacer_name: "#keygop_main" },
            { replacer_name: "#framerate_main" },
            { replacer_name: "#bitrate_main" },
            { replacer_name: "#profile_main" },
            { replacer_name: "#rc_main" },
            { replacer_name: "#quality_main" },
            { replacer_name: "#audioen_main" },
            { replacer_name: "#resolution_sub" },
            { replacer_name: "#keygop_sub" },
            { replacer_name: "#framerate_sub" },
            { replacer_name: "#bitrate_sub" },
            { replacer_name: "#profile_sub" },
            { replacer_name: "#rc_sub" },
            { replacer_name: "#quality_sub" },
            { replacer_name: "#audioen_sub" },
            { replacer_name: "#image_rotation" },
            { replacer_name: "#microphone_level" },
            { replacer_name: "#sound" },
          ];
          callback(null, wordList.map(function(word) {
            return {
              caption: word['replacer_name'],
              value: word['replacer_name'],
              meta: "static"
            };
          }));
        }
      },
      form: {
        config_template: {},
        parsed_replacers: {},
        available_replacers: {},
        available_config_templates: {},
        model_parameters: {},
        model_parameters_for_send: [],
        componentKey: 0,
      },
    };
  },
  computed: {
    ...mapState("cameras", ["config"]),
    ...mapState("cameras", {
      camera: (state) => state.camera,
    }),
  },
  watch: {
    id() {
      this.authKeys = { user_key: null, admin_key: null };
    },
  },
  created() {
    this.fetchData(this.id)
      .then((response) => {
        this.form.config_template = {
          ...response,
        };
      })
      .then(() => this.parseReplacers())
      .then(() =>
        this.getCameraParameters(this.id).then((response) => {
          this.form.model_parameters = {
            ...response,
          };
        })
      )
      .then(() => this.getAvailableReplacers())
      .then(() => this.loading = false)
      .catch(({ response }) => {
        this.$message({
          message: response.data.error,
          type: "error",
        });
        this.loading = false;
      });
  },
  methods: {
    ...mapActions("cameras", {
      getConfig: "GET_CONFIG",
      getAuthKey: "GET_AUTH_KEY",
      resetSettings: "RESET_SETTIGNS",
      updateConfig: "SET_CONFIG",
      getConfigParameters: "GET_CAMERAS_CONFIG_PARAMETERS",
      getCameraParameters: "GET_CAMERA_PARAMETERS",
      setCameraParameters: "SET_CAMERA_PARAMETERS",
      deleteCameraParameters: "DELETE_CAMERA_PARAMETERS",
    }),
    ...mapMutations("cameras", { setConfig: "SET_CONFIG" }),
    refreshConfigEditorList() {
      // Списка параметров нет, если у камеры не задана модель или нет права на их просмотр
      if (this.$refs["configEditorList"]) {
        this.$refs["configEditorList"].refreshForm();
      }
    },
    requestAuthKey(type) {
      const cameraId = this.id;
      const key = `${type}_key`;
      return this.getAuthKey({ id: cameraId, type })
        .then((response) => {
          if (cameraId !== this.id) return;
          if (typeof response?.[key] !== "string" || !response[key]) {
            throw new Error("Не удалось получить пароль камеры");
          }
          this.authKeys[key] = response[key];
        })
        .catch((error) => {
          if (cameraId !== this.id || error?.response?.status === 403) return;
          this.$message({
            message: error?.response?.status === 404
              ? "Не удалось получить пароль: камера не найдена или у неё не указан серийный номер"
              : error?.response?.data?.error || "Не удалось получить пароль камеры",
            type: "error",
          });
        });
    },
    onReset() {
      this.$confirm("Вы точно хотите сбросить настройки у камеры до заводских?", "Подтверждение", {
        confirmButtonText: "Подтвердить",
        type: "warning",
      }).then(() => {
        this.fetch = true;
        this.resetSettings(this.id)
          .then(() => {
            this.$message({
              message: "Настройки у камеры успешно сброшены",
              type: "success",
            });
          })
          .finally(() => {
            this.fetch = false;
          });
      });
    },
    onResetConfiguration() {
      this.$confirm("Вы точно хотите сбросить значения конфигурационных параметров на значения по умолчанию?", "Подтверждение", {
        confirmButtonText: "Подтвердить",
        type: "warning",
      }).then(() => {
        this.fetch = true;
        this.deleteCameraParameters(this.id)
          .then((response) => {
            this.form.model_parameters = {
              ...response,
            };
          })
          .then(() => this.parseReplacers())
          .then(() => {
            this.refreshConfigEditorList();
          })
          .then(() => {
            this.$message({
              message: "Конфигурация успешно сброшена",
              type: "success",
            });
          })
          .finally(() => {
            this.fetch = false;
            // Используется для принудительного обновления компонента с конфигами
            this.form.componentKey++;
          });
      });
    },
    onSave(event) {
      event.preventDefault();
      this.fetch = true;
      if (this.validateReplacers()) {
        this.setCameraParameters({
          id: this.id,
          data: this.form.model_parameters_for_send,
        })
          .then(() =>
            this.updateConfig({
              id: this.id,
              config: this.form.config_template,
            })
          )
          .then(() => {
            this.$message({
              message: "Конфигурация успешно обновлена",
              type: "success",
            });
          })
          .catch(({ response }) => {
            this.$message({
              message: response.data.error,
              type: "error",
            });
          })
          .finally(() => (this.fetch = false));
      } else this.fetch = false;
    },
    fetchData(id) {
      const response = this.getConfig(id);
      return response;
    },
    parseReplacers() {
      const regexLiteral = /#\w+/gm;
      this.form.parsed_replacers = {
        ...JSON.stringify(this.form.config_template).match(regexLiteral),
      };
    },
    getAvailableReplacers() {
      this.getConfigParameters()
        .then((response) =>
            (this.form.available_config_templates = {
              ...response,
            })
        )
        .then(() => {
          const parameters = JSON.parse(JSON.stringify(this.form.available_config_templates));
          for (let i in parameters) {
            this.form.available_replacers[i] = parameters[i].replacer_name;
          }
        })
        .then(() => {
          this.refreshConfigEditorList();
        })
        .catch(({ response }) => {
          this.$message({
            message: response.data.error,
            type: "error",
          });
        });
    },
    setConfig(config = {}) {
      this.form.config_template = config;
      this.parseReplacers();
    },
    validateReplacers() {
      let valid = false;
      for (let i in this.form.parsed_replacers) {
        valid = false;
        for (let k in this.form.available_replacers) {
          if (this.form.available_replacers[k] === this.form.parsed_replacers[i]) {
            valid = true;
          }
        }
        if (!valid) {
          this.$message({
            message: `Неизвестный реплейсер ${this.form.parsed_replacers[i]}`,
            type: "error",
          });
          break;
        }
      }
      return valid;
    },
  },
};
</script>

<style>
  .camera-config__password-action {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .camera-config__password-input {
    min-width: 0;
  }

  .jsoneditor {
    height: calc(85vh - 190px)
  }

  div.jsoneditor-outer {
    height: calc(100% - 25px)
  }

  .section__unavailable {
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
</style>
